import axios from 'axios'
import library from '../../../utils/Library'

export const getSystemDefinedDirStorage = async (suborganizationId, userId) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('storage') +
    '/directory/system/getSystemDefinedDirStorage'
  const params = {
    suborganizationId
  }
  if (userId) params.userId = userId
  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params
  })
}
